import { render, staticRenderFns } from "./patientContactsRep.vue?vue&type=template&id=673650c8&"
import script from "./patientContactsRep.vue?vue&type=script&lang=js&"
export * from "./patientContactsRep.vue?vue&type=script&lang=js&"
import style0 from "./patientContactsRep.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports